import {
  Board,
  Column,
  Dollar,
  Download,
  Home,
  LogoFull,
  Share,
  Team,
  VerifiedUser,
} from 'hatch-components';
import styled from 'styled-components';

export const LEFT_COLUMN_WIDTH = 220;

export const StyledDefaultTemplateLeftColumn = styled(Column)(
  ({ theme: { colors, spacing } }) => ({
    alignItems: 'center',
    background: colors.white,
    borderRight: `1px solid ${colors.lightGrey}`,
    flexShrink: 0,
    flexWrap: 'nowrap',
    height: '100%',
    padding: `${spacing.sm} 0 ${spacing.lg}`,
    width: `${LEFT_COLUMN_WIDTH}px`,
  }),
);

export const StyledScrollableColumn = styled(Column)(
  ({ theme: { spacing } }) => ({
    flex: 1,
    flexShrink: 0,
    flexWrap: 'nowrap',
    margin: `${spacing.lg} 0`,
    overflowY: 'auto',
    width: '100%',
  }),
);

export const StyledLogoFull = styled(LogoFull)(({ theme: { spacing } }) => ({
  flexShrink: 0,
  height: 'auto',
  margin: `0 ${spacing.md}`,
  width: 128,
}));

export const StyledCustomLogo = styled.img(
  ({ theme: { border, spacing } }) => ({
    borderRadius: border.radius.md,
    flexShrink: 0,
    height: 'auto',
    margin: `0 ${spacing.md}`,
    maxHeight: 128,
    maxWidth: 128,
    width: 'auto',
  }),
);

export const StyledBoardIcon = styled(Board)(() => ({
  flexShrink: 0,
  height: 'auto',
  width: 20,
}));

export const StyledShare = styled(Share)(() => ({
  flexShrink: 0,
  height: 'auto',
  transform: 'scaleX(-1)',
  width: 20,
}));

export const StyledDollar = styled(Dollar)(() => ({
  flexShrink: 0,
  height: 'auto',
  width: 20,
}));

export const StyledLogout = styled(Download)(() => ({
  flexShrink: 0,
  height: 'auto',
  transform: 'rotate(-90deg)',
  width: 20,
}));

export const StyledTeam = styled(Team)(() => ({
  flexShrink: 0,
  height: 'auto',
  width: 20,
}));

export const StyledHome = styled(Home)(() => ({
  flexShrink: 0,
  height: 'auto',
  width: 20,
}));

export const StyledShield = styled(VerifiedUser)(() => ({
  flexShrink: 0,
  height: 'auto',
  width: 20,
}));
